import Styles from './styles.module.css';
import 'firebase/auth'
import React, { useState, useEffect, useRef } from 'react';
import DefaultTitle from '../../../../../package/title/index';
import DefaultInput1 from '../../../../../package/1-input/index';
import ErrorMessage from '../../../../../package/error/index';
import { doc, getDoc, getFirestore, updateDoc } from 'firebase/firestore';
import { useAppSelector } from 'src/salon/app/hook';

type RecruitEditStorTypeProps = {
  editPentagon: string;
  setEditPentagon: React.Dispatch<React.SetStateAction<string>>;
};

const RecruitEditStorType: React.FC<RecruitEditStorTypeProps> = ({ editPentagon, setEditPentagon }) => {

  const [ errorMessage, setErrorMessage ] = useState('');
  const [ companyId, setCompanyId ] = useState('');
  const [ showHint, setShowHint ] = useState(false);

  
  const boxRef = useRef<HTMLDivElement>(null);

  // 雰囲気
  const [ pentagonTreatment1, setPentagonTreatment1 ] = useState(1);
  const [ pentagonTreatment2, setPentagonTreatment2 ] = useState(1);
  const [ pentagonTreatment3, setPentagonTreatment3 ] = useState(1);
  const [ pentagonTreatment4, setPentagonTreatment4 ] = useState(1);
  const [ pentagonTreatment5, setPentagonTreatment5 ] = useState(1);
  const [ pentagonTreatment6, setPentagonTreatment6 ] = useState(1);

  // 雰囲気
  const [ pentagonStyle1, setPentagonStyle1 ] = useState(1);
  const [ pentagonStyle2, setPentagonStyle2 ] = useState(1);
  const [ pentagonStyle3, setPentagonStyle3 ] = useState(1);
  const [ pentagonStyle4, setPentagonStyle4 ] = useState(1);
  const [ pentagonStyle5, setPentagonStyle5 ] = useState(1);
  const [ pentagonStyle6, setPentagonStyle6 ] = useState(1);
  const [ pentagonStyleInput, setPentagonStyleInput ] = useState<string>('');


  const company = useAppSelector((state) => state.company.company);

  const db = getFirestore();

  const [ statusPlace, setStatusPlace ] = useState(false);
  const [ statusType, setStatusType ] = useState(false);

  useEffect(() => {
    const fetchStorePentagonData = async () => {
      try {
        const docRef = doc(db, 'stores', editPentagon);
        const docSnap = await getDoc(docRef);
  
        if (!docSnap.exists() || company.id === undefined) return;
  
        const data = docSnap.data();

        setCompanyId(data.companyId);

        // Treatment
        setPentagonTreatment1(data.pentagonTreatment1 ?? 1);
        setPentagonTreatment2(data.pentagonTreatment2 ?? 1);
        setPentagonTreatment3(data.pentagonTreatment3 ?? 1);
        setPentagonTreatment4(data.pentagonTreatment4 ?? 1);
        setPentagonTreatment5(data.pentagonTreatment5 ?? 1);
        setPentagonTreatment6(data.pentagonTreatment6 ?? 1);
  
        // Style Input
        setPentagonStyleInput(data.pentagonStyleInput ?? '');
  
        // Style Values
        setPentagonStyle1(data.pentagonStyle1 ?? 1);
        setPentagonStyle2(data.pentagonStyle2 ?? 1);
        setPentagonStyle3(data.pentagonStyle3 ?? 1);
        setPentagonStyle4(data.pentagonStyle4 ?? 1);
        setPentagonStyle5(data.pentagonStyle5 ?? 1);
        setPentagonStyle6(data.pentagonStyle6 ?? 1);
  
        // Status Flags
        setStatusPlace(data.status_place ?? false);
        setStatusType(data.status_type ?? false);
  
      } catch (error) {
        console.error("Pentagonデータの取得に失敗しました:", error);
      }
    };
  
    fetchStorePentagonData();
  }, []);

  function check() {
    boxRef.current?.scrollTo({ top: 0, behavior: "smooth",});

    if (pentagonTreatment1 === 0) {
      setErrorMessage('カットの点数を記載してください。');
    } else if (pentagonTreatment2 === 0) {
      setErrorMessage('カラーの点数を記載してください。');
    } else if (pentagonTreatment3 === 0) {
      setErrorMessage('パーマの点数を記載してください。');
    } else if (pentagonTreatment4 === 0) {
      setErrorMessage('縮毛矯正の点数を記載してください。');
    } else if (pentagonTreatment5 === 0) {
      setErrorMessage('ヘアメイクを記載してください。');
    } else if (pentagonTreatment6 === 0) {
      setErrorMessage('その他の点数を記載してください。');
    } else if (19 <= (Number(pentagonTreatment1) + Number(pentagonTreatment2) + Number(pentagonTreatment3) + Number(pentagonTreatment4) + Number(pentagonTreatment5) + Number(pentagonTreatment6))) {
      setErrorMessage('施術頻度の合計を18点以下にしてください');
    } else if (pentagonStyle1 === 0) {
      setErrorMessage('かっこいいの点数を記載してください。');
    } else if (pentagonStyle2 === 0) {
      setErrorMessage('トレンドの点数を記載してください。');
    } else if (pentagonStyle3 === 0) {
      setErrorMessage('ナチュラルの点数を記載してください。');
    } else if (pentagonStyle4 === 0) {
      setErrorMessage('クリエイティブの点数を記載してください。');
    } else if (pentagonStyle5 === 0) {
      setErrorMessage('エレガントを記載してください。');
    } else if (pentagonStyleInput === '') {
      setErrorMessage('自由記載を記載してください。');
    } else if (pentagonStyle6 === 0) {
      setErrorMessage('自由記載点数を記載してください。');
    } else if (19 <= (Number(pentagonStyle1) + Number(pentagonStyle2) + Number(pentagonStyle3) + Number(pentagonStyle4) + Number(pentagonStyle5) + Number(pentagonStyle6))) {
      setErrorMessage('施術スタイルの合計を18点以下にしてください');
    } else {
      save(true);
    }

  }

  var hash: string[] = [];

  if (Number(pentagonTreatment1) === 4 || Number(pentagonTreatment1) === 5) {
    hash.push("カットが得意");
  }

  if (Number(pentagonTreatment2) === 4 || Number(pentagonTreatment2) === 5) {
    hash.push("カラーが得意");
  }

  if (Number(pentagonTreatment3) === 4 || Number(pentagonTreatment3) === 5) {
    hash.push("パーマが得意");
  }

  if (Number(pentagonTreatment4) === 4 || Number(pentagonTreatment4) === 5) {
    hash.push("縮毛矯正が得意");
  }

  if (Number(pentagonTreatment5) === 4 || Number(pentagonTreatment5) === 5) {
    hash.push("ヘアメイクが得意");
  }

  if (Number(pentagonStyle1) === 4 || Number(pentagonStyle1) === 5) {
    hash.push("かっこいい施術多め");
  }

  if (Number(pentagonStyle2) === 4 || Number(pentagonStyle2) === 5) {
    hash.push("トレンド感のある施術多め");
  }

  if (Number(pentagonStyle3) === 4 || Number(pentagonStyle3) === 5) {
    hash.push("ナチュラルな施術多め");
  }

  if (Number(pentagonStyle4) === 4 || Number(pentagonStyle4) === 5) {
    hash.push("クリエイティブな施術多め");
  }

  if (Number(pentagonStyle5) === 4 || Number(pentagonStyle5) === 5) {
    hash.push("エレガントな施術多め");
  }

  async function save(isPentagonActive: boolean) {
    const db = getFirestore();
    const recruitId = `${companyId}_2027`;

    const toNumber = (value: unknown) => Number(value);

    // Firestore 更新データをまとめる
    const treatmentValues = [
      pentagonTreatment1, pentagonTreatment2, pentagonTreatment3,
      pentagonTreatment4, pentagonTreatment5, pentagonTreatment6,
    ];
    const styleValues = [
      pentagonStyle1, pentagonStyle2, pentagonStyle3,
      pentagonStyle4, pentagonStyle5, pentagonStyle6,
    ];

    const storeData = {
      status: statusPlace && statusType && isPentagonActive,
      status_pentagon: isPentagonActive,

      // Treatment 系
      ...Object.fromEntries(treatmentValues.map((v, i) => [`pentagonTreatment${i + 1}`, toNumber(v)])),

      // Style 系
      ...Object.fromEntries(styleValues.map((v, i) => [`pentagonStyle${i + 1}`, toNumber(v)])),
      pentagonStyleInput,

      pentagonHash: hash,
      last_time: new Date(),
    };

    // store データ更新
    await updateDoc(doc(db, "stores", editPentagon), storeData);
    setEditPentagon('');

    // recruit 側の更新（isPentagonActive が false のときのみ）
    if (!isPentagonActive) {
      await updateDoc(doc(db, "recruits", recruitId), {
        store: { isCompleted: isPentagonActive },
      });
    }
  }


  return (
    <div className={Styles.box}>

      <div className={Styles.box_inner}>
        <div className={Styles.box_black} onClick={() => setEditPentagon('')}></div>
        <div className={Styles.box_contents}>

          <div className={Styles.header}>
            <div className={Styles.headerTitleWrap}>
              <h3 className={Styles.headerTitle}>六角形</h3>
              <button
                type="button"
                aria-label="この項目の説明"
                aria-expanded={showHint}
                className={showHint ? `${Styles.hintButton} ${Styles.hintButtonActive}` : Styles.hintButton}
                onClick={() => setShowHint((v) => !v)}
              >?</button>
            </div>
            <div className={Styles.headerBtns}>
              <button type="button" className={Styles.backBtn} onClick={() => setEditPentagon('')}>戻る</button>
              <button type="button" className={Styles.saveBtn} onClick={() => check()}>保存</button>
            </div>
          </div>

          {showHint && (
            <div className={Styles.hintPopover}>
              <p>この項目では、どのような施術が多いのかを点数で表現し、どのような施術が多いのかを学生に伝える項目です。</p>
              <p>※ヘア以外の施術に特化している場合は、施術頻度では「その他」を5点にしてください。</p>
            </div>
          )}

          <div className={Styles.body} ref={boxRef} onClick={() => showHint && setShowHint(false)}>

          {errorMessage !== '' ?
            <ErrorMessage message={errorMessage} />
          : <></> }

          <div className={Styles.contents}>
            <h5 className={Styles.title}>施術頻度（現状：{pentagonTreatment1 + pentagonTreatment2 + pentagonTreatment3 + pentagonTreatment4 + pentagonTreatment5 + pentagonTreatment6}点/18点中）</h5>
            
            <div className={Styles.store_contents}>

              <div className={Styles.grid}>

                <div className={Styles.field}>
                  <DefaultTitle title={'カット'} />
                  <select className={Styles.select}
                    value={pentagonTreatment1} onChange={(e) => setPentagonTreatment1(Number(e.target.value))}>
                    <option value={0}>未選択</option>
                    <option value={1}>1点</option>
                    <option value={2}>2点</option>
                    <option value={3}>3点</option>
                    <option value={4}>4点</option>
                    <option value={5}>5点</option>
                  </select>
                </div>

                <div className={Styles.field}>
                  <DefaultTitle title={'カラー'} />
                  <select className={Styles.select}
                    value={pentagonTreatment2} onChange={(e) => setPentagonTreatment2(Number(e.target.value))}>
                    <option value={0}>未選択</option>
                    <option value={1}>1点</option>
                    <option value={2}>2点</option>
                    <option value={3}>3点</option>
                    <option value={4}>4点</option>
                    <option value={5}>5点</option>
                  </select>
                </div>

                <div className={Styles.field}>
                  <DefaultTitle title={'パーマ'} />
                  <select className={Styles.select}
                    value={pentagonTreatment3} onChange={(e) => setPentagonTreatment3(Number(e.target.value))}>
                    <option value={0}>未選択</option>
                    <option value={1}>1点</option>
                    <option value={2}>2点</option>
                    <option value={3}>3点</option>
                    <option value={4}>4点</option>
                    <option value={5}>5点</option>
                  </select>
                </div>

                <div className={Styles.field}>
                  <DefaultTitle title={'縮毛矯正'} />
                  <select className={Styles.select}
                    value={pentagonTreatment4} onChange={(e) => setPentagonTreatment4(Number(e.target.value))}>
                    <option value={0}>未選択</option>
                    <option value={1}>1点</option>
                    <option value={2}>2点</option>
                    <option value={3}>3点</option>
                    <option value={4}>4点</option>
                    <option value={5}>5点</option>
                  </select>
                </div>

                <div className={Styles.field}>
                  <DefaultTitle title={'ヘアメイク'} />
                  <select className={Styles.select}
                    value={pentagonTreatment5} onChange={(e) => setPentagonTreatment5(Number(e.target.value))}>
                    <option value={0}>未選択</option>
                    <option value={1}>1点</option>
                    <option value={2}>2点</option>
                    <option value={3}>3点</option>
                    <option value={4}>4点</option>
                    <option value={5}>5点</option>
                  </select>
                </div>

                <div className={Styles.field}>
                  <DefaultTitle title={'その他'} />
                  <select className={Styles.select}
                    value={pentagonTreatment6} onChange={(e) => setPentagonTreatment6(Number(e.target.value))}>
                    <option value={0}>未選択</option>
                    <option value={1}>1点</option>
                    <option value={2}>2点</option>
                    <option value={3}>3点</option>
                    <option value={4}>4点</option>
                    <option value={5}>5点</option>
                  </select>
                </div>

              </div>

            </div>

          </div>

          <div className={Styles.contents}>
            <h5 className={Styles.title}>スタイル頻度（現状：{pentagonStyle1 + pentagonStyle2 + pentagonStyle3 + pentagonStyle4 + pentagonStyle5 + pentagonStyle6}点/18点中）</h5>
            
            <div className={Styles.store_contents}>

              <div className={Styles.grid}>

                <div className={Styles.field}>
                  <DefaultTitle title={'かっこいい'} />
                  <select className={Styles.select}
                    value={pentagonStyle1} onChange={(e) => setPentagonStyle1(Number(e.target.value))}>
                    <option value={0}>未選択</option>
                    <option value={1}>1点</option>
                    <option value={2}>2点</option>
                    <option value={3}>3点</option>
                    <option value={4}>4点</option>
                    <option value={5}>5点</option>
                  </select>
                </div>

                <div className={Styles.field}>
                  <DefaultTitle title={'トレンド'} />
                  <select className={Styles.select}
                    value={pentagonStyle2} onChange={(e) => setPentagonStyle2(Number(e.target.value))}>
                    <option value={0}>未選択</option>
                    <option value={1}>1点</option>
                    <option value={2}>2点</option>
                    <option value={3}>3点</option>
                    <option value={4}>4点</option>
                    <option value={5}>5点</option>
                  </select>
                </div>

                <div className={Styles.field}>
                  <DefaultTitle title={'ナチュラル'} />
                  <select className={Styles.select}
                    value={pentagonStyle3} onChange={(e) => setPentagonStyle3(Number(e.target.value))}>
                    <option value={0}>未選択</option>
                    <option value={1}>1点</option>
                    <option value={2}>2点</option>
                    <option value={3}>3点</option>
                    <option value={4}>4点</option>
                    <option value={5}>5点</option>
                  </select>
                </div>

                <div className={Styles.field}>
                  <DefaultTitle title={'クリエイティブ'} />
                  <select className={Styles.select}
                    value={pentagonStyle4} onChange={(e) => setPentagonStyle4(Number(e.target.value))}>
                    <option value={0}>未選択</option>
                    <option value={1}>1点</option>
                    <option value={2}>2点</option>
                    <option value={3}>3点</option>
                    <option value={4}>4点</option>
                    <option value={5}>5点</option>
                  </select>
                </div>

                <div className={Styles.field}>
                  <DefaultTitle title={'エレガント'} />
                  <select className={Styles.select}
                    value={pentagonStyle5} onChange={(e) => setPentagonStyle5(Number(e.target.value))}>
                    <option value={0}>未選択</option>
                    <option value={1}>1点</option>
                    <option value={2}>2点</option>
                    <option value={3}>3点</option>
                    <option value={4}>4点</option>
                    <option value={5}>5点</option>
                  </select>
                </div>

                <div className={`${Styles.field} ${Styles.fieldFull}`}>
                  <DefaultInput1
                    error={false}
                    title={'自由記載'} length={8} place={''} value={pentagonStyleInput} setValue={setPentagonStyleInput} desc={''}  hint={{title: "", desc: ""}} />
                  <select className={Styles.select}
                    value={pentagonStyle6} onChange={(e) => setPentagonStyle6(Number(e.target.value))}>
                    <option value={0}>未選択</option>
                    <option value={1}>1点</option>
                    <option value={2}>2点</option>
                    <option value={3}>3点</option>
                    <option value={4}>4点</option>
                    <option value={5}>5点</option>
                  </select>
                  <p className={Styles.sectionNote}>※自由記載はサロン様の強みを記載いただき、高得点を配分することで学生に魅力を伝えることができます。</p>
                </div>

              </div>

            </div>

          </div>

          </div>

        </div>
      </div>
    </div>
  );
}

export default RecruitEditStorType;
